import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DocketwiseSettingsState = {
  docketwiseEnableDetails: false,
  docketwiseSettings: {},
  docketwiseSettingsLoading: false,
}

export const DocketwiseSettingsActions = {
  createDocketwiseSettings: async ({ commit }, value) => {
    commit('setDocketwiseSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'docketwise',
        value,
      }).
      then(({ data }) => {
        commit('setDocketwiseSettings', data)
        commit('setDocketwiseEnableDetails', false)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setDocketwiseSettingsLoading', false))
  },

  getDocketwiseSettings: async ({ commit }) => {
    commit('setDocketwiseSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/docketwise').
      then(({ data }) => {
        commit('setDocketwiseSettings', data)
        commit('setDocketwiseEnableDetails', false)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setDocketwiseSettingsLoading', false))
  },

  updateDocketwiseSettings: async ({ commit, getters }, value) => {
    commit('setDocketwiseSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.docketwiseSettingsId}`, {
        name: 'docketwise',
        value,
      }).
      then(({ data }) => {
        commit('setDocketwiseSettings', data)
        commit('setDocketwiseEnableDetails', false)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setDocketwiseSettingsLoading', false))
  },

  deleteDocketwiseSettings: async ({ getters, commit }) => {
    commit('setDocketwiseSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.docketwiseSettingsId}`).
      then(({ data }) => {
        commit('setDocketwiseSettings', data)
        commit('setDocketwiseEnableDetails', false)
      }).
      catch(handleError).
      finally(_ => commit('setDocketwiseSettingsLoading', false))
  },

  clearDocketwiseFromSystem: async ({ commit }, options) => {
    commit('setDocketwiseSettingsLoading', true)

    return axiosRequest.
      delete('/admin/docketwise/contacts', options).
      catch(handleError).
      finally(_ => commit('setDocketwiseSettingsLoading', false))
  },

  clearDocketwiseTokens: async ({ commit }) => {
    commit('setDocketwiseSettingsLoading', true)

    return axiosRequest.
      delete('/admin/docketwise/tokens').
      catch(handleError).
      finally(_ => commit('setDocketwiseSettingsLoading', false))
  },

  clearDocketwiseSettings: ({ commit }) => {
    commit('setDocketwiseSettings', null)
  },

  setDocketwiseEnableDetails: ({ commit }, value) => {
    commit('setDocketwiseEnableDetails', value)
  },
}

export const DocketwiseSettingsMutations = {
  setDocketwiseEnableDetails: (state, payload) => { state.docketwiseEnableDetails = payload },
  setDocketwiseSettings: (state, payload) => { state.docketwiseSettings = payload },
  setDocketwiseSettingsLoading: (state, payload) => { state.docketwiseSettingsLoading = payload },
  setDocketwiseSettingsValue: (state, payload) => { state.docketwiseSettings.value = payload },
}

export const DocketwiseSettingsGetters = {
  docketwiseEnableDetails: state => state.docketwiseEnableDetails,
  docketwiseSettings: state => state.docketwiseSettings,
  docketwiseSettingsId: state => state.docketwiseSettings?.id,
  docketwiseSettingsLoading: state => state.docketwiseSettingsLoading,
  docketwiseSettingsValue: state => state.docketwiseSettings?.value,
}
